export const VERIFICATION_ENDPOINT =
  "https://whofu14kdb.execute-api.us-west-2.amazonaws.com/prod/auth";
